if (!customElements.get("product-request-information")) {
  customElements.define(
    "product-request-information",
    class ProductRequestInformation extends HTMLElement {
      constructor() {
        super();

        this.onSubmit = this.onSubmit.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.collapsed = this.getAttribute("expanded") === "false";
        this.toggleElement = this.querySelector(".product-request-information-toggle");
        this.form = this.closest("form");
        this.toggleElement?.addEventListener("click", this.onToggle);
        this.form?.addEventListener("submit", this.onSubmit);

        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.productVariantChange,
            this.onVariantChange,
          );
        }

        if (this.dataset.postedSuccessfully === "true") {
          this.publishSuccessfulEnquiry();
        }
      }

      disconnectedCallback() {
        this.toggleElement?.removeEventListener("click", this.onToggle);
        this.form?.removeEventListener("submit", this.onSubmit);
        this.variantChangeUnsubscriber?.();
      }

      onToggle(event) {
        event.preventDefault();
        this.handleToggle();
      }

      collapse() {
        this.setAttribute("expanded", "false");
        this.toggleElement.setAttribute("aria-expanded", "false");
        this.collapsed = true;
      }

      expand() {
        this.setAttribute("expanded", "true");
        this.toggleElement.setAttribute("aria-expanded", "true");
        this.collapsed = false;
        this.querySelector('input[name="contact[name]"]')?.focus();
      }

      handleToggle() {
        if (this.collapsed) {
          this.expand();
        } else {
          this.collapse();
        }
      }

      onSubmit() {
        try {
          sessionStorage.setItem(this.pendingTrackingKey(), "true");
        } catch (_error) {
          // The form still works when browser storage is unavailable.
        }
      }

      onVariantChange(data) {
        if (data.sectionId !== this.dataset.sectionId || !data.variant) return;

        const variant = data.variant;
        this.dataset.variantId = variant.id?.toString() || "";
        this.dataset.variantTitle = variant.title || "";
        this.dataset.variantSku = variant.sku || "";
        this.dataset.variantPrice = variant.price?.toString() || "";

        this.updateField("[data-enquiry-variant-id]", this.dataset.variantId);
        this.updateField("[data-enquiry-variant-title]", this.dataset.variantTitle);
        this.updateField("[data-enquiry-variant-sku]", this.dataset.variantSku);
        this.updateField(
          "[data-enquiry-variant-price]",
          this.formatPrice(variant.price),
        );
      }

      updateField(selector, value) {
        const field = this.querySelector(selector);
        if (field) field.value = value || "";
      }

      formatPrice(priceInCents) {
        if (typeof priceInCents !== "number") return "";

        try {
          return new Intl.NumberFormat(document.documentElement.lang || "en-AU", {
            style: "currency",
            currency: this.dataset.currency || "AUD",
          }).format(priceInCents / 100);
        } catch (_error) {
          return `${(priceInCents / 100).toFixed(2)} ${this.dataset.currency || "AUD"}`;
        }
      }

      pendingTrackingKey() {
        return `machine-enquiry-pending:${this.dataset.productId}`;
      }

      publishSuccessfulEnquiry() {
        let submissionIsPending = false;

        try {
          submissionIsPending = sessionStorage.getItem(this.pendingTrackingKey()) === "true";
          sessionStorage.removeItem(this.pendingTrackingKey());
        } catch (_error) {
          // Avoid duplicate analytics when browser storage is unavailable.
          return;
        }

        if (!submissionIsPending) return;

        const eventData = {
          product_id: this.dataset.productId,
          product_title: this.dataset.productTitle,
          product_url: this.dataset.productUrl,
          variant_id: this.dataset.variantId,
          variant_title: this.dataset.variantTitle,
          sku: this.dataset.variantSku,
          value: Number(this.dataset.variantPrice || 0) / 100,
          currency: this.dataset.currency || "AUD",
        };

        let attempts = 0;
        const publishEvent = () => {
          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(
              "woodworking_emporium:machine_enquiry_submitted",
              eventData,
            );
            return;
          }

          attempts += 1;
          if (attempts < 20) window.setTimeout(publishEvent, 250);
        };

        publishEvent();
      }
    },
  );
}
